export const copyToClipboard = (value: string): void => {
    const tempBox = document.createElement('textarea');

    document.body.appendChild(tempBox);
    tempBox.value = value;
    tempBox.select();
    document.execCommand('copy');
    document.body.removeChild(tempBox);
};
